import React from "react";
import Layout from "../Components/Layout/Layout";

const PageNotFound = () => {
  return (
    <Layout title="Page not Found - Cara" author="shobhit pandey">
      <h1 style={{ marginTop: "10vh" }}>PageNotFound</h1>
    </Layout>
  );
};

export default PageNotFound;
